import { defaultResumeData, idSchema, jobMatchSchema, resumeDataSchema } from "@reactive-resume/schema";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

import { userSchema } from "../user";

export const resumeSchema = z.object({
  id: idSchema,
  title: z.string(),
  slug: z.string(),
  data: resumeDataSchema.default(defaultResumeData),
  visibility: z.enum(["private", "public"]).default("private"),
  locked: z.boolean().default(false),
  userId: idSchema,
  user: userSchema.optional(),
  createdAt: z.date().or(z.dateString()),
  updatedAt: z.date().or(z.dateString()),
  jobCompanyName: z.string().nullable().default(""),
  jobTitle: z.string().nullable().default(""),
  jobDescription: z.string().nullable().default(""),
  atsFinalScore: z.number().nullable().default(null),
  atsRelevanceScore: z.number().nullable().default(null),
  atsClarityScore: z.number().nullable().default(null),
  atsImpactScore: z.number().nullable().default(null),
  // Written only by the Job Match endpoints; resume updates never touch it.
  jobMatch: jobMatchSchema.nullable().optional(),
});

export class ResumeDto extends createZodDto(resumeSchema) {}
